// extracted by mini-css-extract-plugin
export default {"header-wrapper":"Header_header-wrapper__GJjGi","header":"Header_header__-g0G7","logo":"Header_logo__X0SzY"};